// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalAddControls_basic-panel__R8zUp","title":"ModalAddControls_title__YZaNM","actions":"ModalAddControls_actions__bfjAC"};